import { UserAccess, lifehomeProps } from './context';

export enum UserAccessActionTypes {
  REFRESH,
  LOGOUT,
}

export interface RefreshUserAccess {
  type: UserAccessActionTypes.REFRESH;
  payload: UserAccess;
}

export interface LogoutUserAccess {
  type: UserAccessActionTypes.LOGOUT;
}

export type UserAccessActions = RefreshUserAccess | LogoutUserAccess;

export enum lifeHomeActionTypes {
  REFRESH,
}
export interface RefreshLifeHome {
  type: lifeHomeActionTypes.REFRESH;
  payload: lifehomeProps;
}
export type lifeHomeActions = RefreshLifeHome;
